module.exports = __webpack_public_path__ + "static/img/tuomasi.5a39b6b5.png";